<template>
  <div class="imgsList">
    <draggable
      :options="{
        animation: 150,
        scroll: true,
        scrollSensitivity: 200
      }"
      v-model="uploadList"
      :move="move"
      @end="end"
      class="draggable"
    >
      <div v-for="item in uploadList" :key="item.index">
        <template>
          <img :src="item" />
          <Icon
            type="md-close-circle"
            color="#e90d0d"
            class="delImgs"
            size="20"
            @click="handleRemove(item)"
          />
          <!-- <span class="delImgs" @click="handleRemove(item)">×</span> -->
        </template>
      </div>
      <div :class="show ? '' : 'none'">
        <Uploadify
          :options="options"
          ref="uploadify"
          @getOssRes="getOssRes"
        ></Uploadify>
      </div>
    </draggable>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
// import Cookies from 'js-cookie'
// import { TOKEN_KEY } from '@/libs/util'
// import { getImgs } from '@/api/myweb/goods/goodsManagement'
import Uploadify from '@/views/base/uploadify/upload.vue'
export default {
  components: { draggable, Uploadify },
  data() {
    return {
      options: {
        size: 6,
        optionbtn: false,
        optionbtn1: false,
        edit: true,
        fileType: ['jpg', 'png', 'jpeg', 'psd', 'gif', 'bmp']
      },
      partId: '',
      defaultList: [],
      imgName: '',
      visible: false,
      uploadList: [], // 已存在的图片列表
      fileList: [], //不知道是啥图片数组
      startNum: 0, //  初始图片数量
      show: true
    }
  },
  methods: {
    getOssRes(res) {
      console.log(res.url)
      this.uploadList.push(res.url)
      console.log(this.uploadList)
      if (this.uploadList.length >= 4) {
        this.show = false
      } else {
        this.show = true
      }
      this.defaultList = []
      this.uploadList.forEach((item, index) => {
        this.defaultList.push({ imgAddress: item, sort: index })
      })

      this.$emit('getImg', this.defaultList)
    },
    // // 删除图片
    handleRemove(file) {
      console.log(file)
      this.uploadList.splice(this.uploadList.indexOf(file), 1)
      if (this.uploadList.length >= 4) {
        this.show = false
      } else {
        this.show = true
      }
      console.log(this.uploadList)
      this.defaultList = []
      this.uploadList.forEach((item, index) => {
        this.defaultList.push({ imgAddress: item, sort: index })
      })
      this.$emit('getImg', this.defaultList)
    },

    // 获取初始图片
    async getImgs(imgList) {
      console.log(imgList)
      this.startNum = imgList.length
      console.log(this.startNum)
      if (this.startNum >= 4) {
        this.show = false
      } else {
        this.show = true
      }
      this.uploadList = []

      imgList.forEach(item => {
        this.$set(this.uploadList, item.sort, item.imgAddress)
      })

      console.log(this.uploadList)
    },

    //  ***********************************************
    move: function(evt) {
      if (!evt.draggedContext.element) return false
      return true
    },
    // 拖拽事件
    end: function(evt) {
      // evt.item // 以知道拖动的本身
      // evt.to // 可以知道拖动的目标列表
      // evt.from // 可以知道之前的列表
      // evt.oldIndex // 可以知道拖动前的位置
      // evt.newIndex // 可以知道拖动后的位置
      console.log(this.uploadList)
      this.defaultList = []
      this.uploadList.forEach((item, index) => {
        this.defaultList.push({ imgAddress: item, sort: index })
      })
      this.$emit('getImg', this.defaultList)
    }
  },
  mounted() {}
}
</script>
<style lang="less" scoped>
/deep/.ivu-upload-drag {
  border: 1px dashed #3f83d8;
}
.imgsList {
  .draggable {
    display: inline-block;
    overflow: inherit;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: left;
    flex-direction: row;
    > div {
      position: relative;
      display: inline-block;

      img {
        width: 74px;
        height: 74px;
        margin-right: 10px;
      }
      .delImgs {
        // width: 20px;
        // height: 20px;
        // line-height: 20px;
        text-align: center;
        position: absolute;
        right: 5px;
        top: -5px;
        color: #fff;
        background-color: #fff;
        cursor: pointer;
        // font-size: 26px;
        border-radius: 13px;
      }
    }
    .uploadImgs {
      margin: 10px;
      position: relative;
      top: -10px;
      // position: absolute;
      .box {
        background-color: #fff;
        border: none;
        width: 158px;
        height: 158px;
        line-height: 158px;
      }
    }
  }
}
.none {
  display: none !important;
}
</style>
